// extracted by mini-css-extract-plugin
export default {"modalSizeFix":"notes_modalSizeFix__DRk0i","noteBody":"notes_noteBody__+tUmV"};